<template>
<div>
  <p>La structure du bâtiment joue un rôle essentiel dans son aptitude à ralentir l'élévation de la température de l'air intérieur, et par sa capacité à absorber l'énergie thermique incidente : on parle alors «&nbsp;d'inertie thermique&nbsp;».</p>

  <p>Une attention doit alors être portée à la structure du bâtiment, et donc aux matériaux qui la composent (ce sont les matériaux lourds, et notamment le béton, la pierre, la brique qui possèdent les meilleures qualités vis à vis de l'inertie thermique), en favorisant l'isolation par l'extérieur qui protège les parois du rayonnement, et en veillant à la nature des isolants utilisés.</p>
</div>


</template>